<template>
  <div class="container">
    <div>
      <div class="p-3">
        <b-loading
          :is-full-page="true"
          v-model="loading"
          :can-cancel="true"
        ></b-loading>
        <div v-if="!loading">
          <div class="mb-5">
            <router-link to="/planned-trips" class="has-text-weight-bold"
              >Trips</router-link
            >
            >
            <router-link
              :to="{
                name: 'trip-detail',
                params: {
                  recordLocator: this.trip.recordLocator,
                  tripProp: trip,
                },
              }"
              class=""
              >Trip Details</router-link
            >
            >
            <span class="has-text-weight-light">Cancel {{ segment.type }}</span>
          </div>
          <b-icon icon="arrow_left" size=""></b-icon>

          <div class="box mb-5 p-5">
            <div class="columns is-centered">
              <div class="column is-narrow mt-1">
                <b-icon icon="wallet-travel mt-6" size="is-medium"></b-icon>
              </div>
              <div class="column">
                <b-collapse
                  aria-id="contentIdForA11y2"
                  class="type-panel mb-6"
                  animation="slide"
                >
                 
                    <div
                      class="section-title is-size-4 has-text-weight-medium"
                      role="button"
                      aria-controls="contentIdForA11y2"
                    >
                      Your {{ $helpers.capitalize(segment.type) }} Reservation
                    </div>
                 
                  <div class="section-body">
                    <div v-if="segment.type == 'hotel'">
                      <HotelSegment :segment="segment" />
                    </div>

                    <div v-else-if="segment.type == 'car'">
                      <CarSegment :segment="segment" />
                    </div>

                    <div class="cancel-section">
                      
                      <!-- Get CXL object from HotelReservationDetails, if available -->
                      <CancelDetail
                        v-if="cancelPolicy"
                        :cancelPolicy="cancelPolicy"
                        :pnrCxlText="segment.cxlPolicy"
                        class = "mt-6"
                      />

                      <!-- If no cancel policy in the HotelReservationDetails, show the CXL text from the PNR (if any) -->
                      <div v-else-if="segment.cxlPolicy" class="mb-3">
                        {{ lowercase(segment.cxlPolicy) }}
                      </div>

                      <hr />
                      <button
                        v-if="showCancel && !cancelDialog"
                        class="button is-info mt-4 is-small"
                        @click="cancelDialog = true"
                      >
                        Cancel
                        {{ $helpers.capitalize(segment.type) }} Reservation
                      </button>

                      <div class="my-5" v-if="cancelDialog">

                        <CancelNotification v-if="cancelPolicy"
                        :cancelPolicy="cancelPolicy" />

                        <div class="mt-6 mb-2 has-text-danger">
                          Are you sure you wish to cancel this booking? This
                          action cannot be undone.
                        </div>
                        <button
                          class="button is-info mt-4 is-small"
                          @click="cancelSegment(segment)"
                        >
                          Yes, Cancel This Reservation
                        </button>
                        <button
                          class="button is-info mt-4 ml-2 is-outlined is-small"
                          @click="cancelDialog = false"
                        >
                          Do Not Cancel
                        </button>
                      </div>

                      <b-progress
                        v-if="cancelLoader"
                        type="is-success my-2"
                        style="max-width: 300px"
                      ></b-progress>

                      <div class="mt-4 mb-2 has-text-danger">
                        {{ cancelMessage }}
                      </div>
                    </div>
                  </div>
                </b-collapse>

                <!-- Start segment -->
              </div>
            </div>

            <!--
            <b-modal v-model="modalActive" :width="320" scroll="keep">
              <div class="card bg-white p-4">
                <header class="card-header">
                  <p class="card-header-title"></p>
                  <button
                    class="delete"
                    aria-label="close"
                    @click="modalActive = false"
                  ></button>
                </header>

                <div v-if="cancelLoader" class="p-6">
                  <b-loading
                    :is-full-page="false"
                    v-model="cancelLoader"
                    :can-cancel="true"
                  ></b-loading>
                </div>

                <div v-else-if="cancelMessage">{{ cancelMessage }}</div>

                <div v-else>
                  <div class="mb-4 has-text-danger">
                    Are you sure you wish to cancel this booking? This action
                    cannot be undone.
                  </div>
                  <b-button class="is-danger mr-3" @click="voidTicket"
                    >Yes, cancel my booking</b-button
                  >

                  <b-button class="is-info" @click="modalActive = false"
                    >Exit</b-button
                  >
                </div>
              </div>
            </b-modal>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import AirSegment from "@/components/Trip/AirSegment.vue";
import CarSegment from "@/components/Trip/CarSegment.vue";
import HotelSegment from "@/components/Trip/HotelSegment.vue";
import CancelDetail from "../components/Trip/Cancellation/CancelDetail.vue";
import CancelNotification from "../components/Trip/Cancellation/CancelHotelNotification.vue";

export default {
  name: "SegmentCancel",
  components: { CarSegment, HotelSegment, CancelDetail, CancelNotification },
  props: {
    //a base64 encoded version of the actual Amadeus record locator;
    //used in the url for obscurity
    recordLocatorHash: {
      required: true,
      type: String,
    },
    tattoo: {
      required: true,
      type: String,
    },
    tripProp: {
      required: false,
      //type: Object,
    },
  },
  data() {
    return {
      details: {},
      ticket: {},
      trip: {},
      error: {},
      loading: false,
      rateInformation: null,
      totalAmount: null,
      rateInclusions: null,
      cancellationPolicies: null,
      bookingRequirements: null,
      otherInfo: null,
      roomDescription: null,
      modalActive: false,
      cancelLoader: false,
      cancelMessage: null,
      cancelResult: null,
      cancelDialog: false,
      creditDialog: false,
      showCancel: true,
    };
  },
  computed: {
    //convert the Base64 hash to the actual Amadeus record locator
    recordLocator() {
      return this.$helpers.decryptText(this.recordLocatorHash);
    },
    cancelPolicy() {
      return this.cancellationPolicies;
    },
    flightSegments() {
      return this.trip.segments.filter((segment) => segment.type == "air");
    },
    carSegments() {
      return this.trip.segments.filter((segment) => segment.type == "car");
    },
    hotelSegments() {
      return this.trip.segments.filter((segment) => segment.type == "hotel");
    },
    segment() {
      return this.trip.segments?.find(
        (segment) => segment.tattoo == this.tattoo
      );
    },
    travellerProfile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
  },
  methods: {
    /*
    launchCancelModal(segment) {
      let config = {
        parent: this,
        component: CancellationModal,
        props: {
          segment: segment,
        },
        trapFocus: false,
        width: 900,
      };
      this.$buefy.modal.open(config);
    },
    */
    lowercase(text) {
      return text
        ? text[0].toUpperCase() + text.substring(1).toLowerCase()
        : null;
    },
    async getHotelData() {
      var post = {
        stateful: true,
        sessionKey: null,
        //sessionKey:"file:HuddleLabs/Amadeus/XmlObjects/Hotel/hotelCompleteReservationDetails.xml",
        normalizeResponse: true,
        recordLocator: this.recordLocator,
        segmentTattoo: this.segment.tattoo,
        officeId: this.$globals.profile.officeId,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/hotel/pnr-reservation-details",
        post
      );

      let data = result.data;

      this.details = data.reservationDetails;

      this.rateInformation = this.details.rateInformation;
      this.rateInclusions = this.details.rateInclusions;
      this.cancellationPolicies = this.details.cancellationPolicies;
      this.bookingRequirements = this.details.bookingRequirements;
      this.otherInfo = this.details.otherInfo;
      this.roomDescription = this.details.roomDescription;

      //this.error = response.errorInformation;
    },
    async getTrip() {
      var post = {
        meta: {
          stateful: true,
          sessionKey: null,
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Hotel/hotelCompleteReservationDetails.xml",
          normalizeResponse: true,
        },

        recordLocator: this.recordLocator,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/trips/show",
        post
      );

      return result;
    },
    async cancelSegment(segment) {
      this.cancelLoader = true;

      var post = {
        meta: {
          stateful: true,
          sessionKey: null,
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Pnr/Pnr_Cancel_Flight.xml",
          //sessionKey: "file:HuddleLabs/Amadeus/XmlObjects/Pnr/Pnr_Cancel_Fail.xml",
        },
        recordLocator: this.recordLocator,
        cancelItinerary: false,
        segments: segment.tattoo, //Array.of(segment),
        requester: this.travellerProfile.email,
      };

      let result = await this.$app.huddleLabsServerCall(
        "amadeus/trips/cancel-segment",
        post
      );

      if (result.status == "OK") {
        this.cancelMessage = "Reservation has been successfully canceled.";
      } else {
        this.cancelMessage =
          "We experienced an error when trying to cancel this booking. Please contact Gant Travel at 877-924-0303. ";

        let errmsg = this.$helpers.getSafe(() => result.messages[0].text);

        if (errmsg)
          this.cancelMessage +=
            " The following error message was received: " + errmsg;
      }

      this.cancelLoader = false;
      this.cancelDialog = false;
      this.showCancel = false;
    },
    async init() {
      let result = await this.getTrip();
      this.trip = result.data;
    },
  },
  watch: {
    async $route(to, from) {
      this.loading = true;
      await this.init();
      this.loading = false;
    },
  },

  //TO DO: Move loading to route watcher insted of mounted hook
  async mounted() {
    this.loading = true;

    if (this.tripProp && typeof this.tripProp === "object") {
      this.trip = this.tripProp;
    } else {
      await this.init();
    }

    if (this.segment.type == "hotel") {
      await this.getHotelData();
    }
    this.loading = false;
  },
};
</script>

<style>
ul {
  list-style-type: disc;
  margin-left: 25px;
}

.type-panel {
  border: 1px rgb(226, 223, 223) solid;
  border-radius: 6px;
}

.section-title {
  border-bottom: 1px solid #ddddde;
  padding: 24px 32px;
  position: relative;
  top: 1px;
}

.section-body {
  padding: 24px 32px;
  position: relative;
  top: 1px;
}
</style>
